import PageSEO from '@/components/base/PageSEO';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import LatestContent from './components/LatestContent';
import FAQSection from './components/FAQSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '火影同人创作指南',
  url: 'https://naruto-fancreations.com',
  description: '最全面的火影忍者同人创作平台，汇聚创作灵感、技巧教程与社区资源。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://naruto-fancreations.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '火影同人创作指南',
  url: 'https://naruto-fancreations.com',
  description: '火影忍者同人创作综合平台',
  sameAs: ['https://weibo.com', 'https://bilibili.com'],
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '什么是火影忍者同人创作？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '火影忍者同人创作是指基于《火影忍者》原作世界观、角色、剧情等元素进行的二次创作。包括同人小说、同人插画、同人漫画、CP配对创作等多种形式。',
      },
    },
    {
      '@type': 'Question',
      name: '新手如何开始火影同人创作？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '新手建议从短篇同人小说或简单角色插画开始。首先要充分理解火影忍者的世界观和角色性格，然后选择一个感兴趣的创作方向。',
      },
    },
    {
      '@type': 'Question',
      name: '火影同人创作有哪些热门方向？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '目前最热门的火影同人创作方向包括：鸣佐CP同人、平行世界/IF线剧情、角色重塑、晓组织视角的故事、穿越/重生题材等。',
      },
    },
    {
      '@type': 'Question',
      name: '同人创作需要注意哪些版权问题？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '同人创作属于二次创作范畴。创作者应注意标注原作版权归属、声明为非商业性创作、尊重原作基础设定不过度扭曲角色。',
      },
    },
    {
      '@type': 'Question',
      name: '如何提高同人作品的质量和人气？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '提高作品质量需要持续练习和积累：多看优秀的同人作品学习技巧、重视角色性格的准确性、注重文笔/画工的提升。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="火影忍者同人——创作者必看的完整指南 | 同人小说·插画·CP·剧情创作教程"
        description="探索火影忍者同人的世界：原创剧情、人物重塑、CP配对、同人小说与插画创作技巧全解析。无论你是新手还是资深同人作者，这里汇聚最全面的火影忍者同人创作灵感与资源，帮你打造令粉丝疯狂的同人作品。"
        canonicalUrl="https://naruto-fancreations.com/"
        keywords="火影忍者同人,火影忍者同人小说,火影忍者同人插画,火影忍者CP同人,火影忍者同人剧情,火影忍者同人创作教程,火影忍者二次创作"
        jsonLd={{ ...homeJsonLd, ...orgJsonLd, ...faqJsonLd }}
      />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <LatestContent />
        <FAQSection />
      </main>
    </>
  );
}